import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';

// render pages
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/index')));
const SettingsPage = Loadable(lazy(() => import('pages/dashboard/Settings')));
const HistoryPage = Loadable(lazy(() => import('pages/dashboard/History')));
const FileMetadataOpener = Loadable(
    lazy(() => import('pages/file_metadata/View')),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes: RouteObject = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '',
            element: <DashboardDefault />,
        },
        {
            path: 'settings',
            element: <SettingsPage />,
        },
        {
            path: 'history',
            element: <HistoryPage />,
        },
        {
            path: 'file_metadata/:id',
            element: <FileMetadataOpener />,
        },
    ],
};

export default MainRoutes;
